import { getSubmissionGradingStatusId, isSubmissionRejected, SubmissionGradingStatus, SubmissionStatusId } from '@module/assignment';
export var isAttendeeResolvedForScorePublishing = function isAttendeeResolvedForScorePublishing(report) {
  var _report$status, _report$status$id;

  var statusId = (_report$status = report.status) === null || _report$status === void 0 ? void 0 : (_report$status$id = _report$status.id) === null || _report$status$id === void 0 ? void 0 : _report$status$id.toString();
  var gradingStatusId = getSubmissionGradingStatusId(report.gradingStatus);
  return statusId === SubmissionStatusId.BANNED || Boolean(report.rejectionInfo) || isSubmissionRejected(report.gradingStatus) || gradingStatusId === SubmissionGradingStatus.GRADED || report.gradedPercentage === 100;
};
export var areAllAttendeesResolvedForScorePublishing = function areAllAttendeesResolvedForScorePublishing(reports) {
  return reports.length > 0 && reports.every(function (report) {
    return isAttendeeResolvedForScorePublishing(report);
  });
};